// extracted by mini-css-extract-plugin
export default {"container":"image-previewer_container__pVoUQ","image_wrapper":"image-previewer_image_wrapper__oh81B","close_button":"image-previewer_close_button__y11TW"};